import { useCurrentUserCheckInputRequiredProfileRedirect } from '@findy-code/yuffie/graphql';
import { NotFoundV2 } from '@findy-code/yuffie/shared/errors';
import { Column, Row } from '@findy-code/yuffie/shared/styles';

import { useCompanyJobDescriptionDetailV2Facade } from './company-job-description-detail.facade';
import { CompanyJobDescriptionDetail } from './components/company-job-description-detail';
import type {
  FetchJobDescriptionDetailFragment,
  JobDescriptionSpeakerDeckOembedFragment,
} from './graphql';

type Props = {
  isLogin: boolean;
  jdHash: string;
  mailReferrer: string;
  redirectPath: string;
  jobDescription: FetchJobDescriptionDetailFragment | null;
  jobDescriptionSpeakerDeckOembed?: JobDescriptionSpeakerDeckOembedFragment | null;
};
/**
 * Container部分は分割する可能性があるので名前は変わるかも
 * 名前が既存の重複するが、後々変えるのが面倒になるかもなのでexportで名前変えておく
 */
export const CompanyJobDescriptionDetailV2Container = ({
  isLogin,
  jdHash,
  mailReferrer,
  redirectPath,
  jobDescription,
  jobDescriptionSpeakerDeckOembed,
}: Props) => {
  const { inputRequiredProfileRedirectStatus } =
    useCurrentUserCheckInputRequiredProfileRedirect({
      redirectParamsPath: redirectPath,
    });

  const {
    isLoading,
    isLoadingCurrentUser,
    isFirstLoaded,
    isBlockCompany,
    isUserSuccessCommitmentJobInterview,
    isOpenedMatchModal,
    userSelfRecommendSkillIds,
    userSkillIds,
    userPersonalityIds,
    currentUser,
    jobDescriptionDataForRender,
    jobDescriptionLike,
    userLike,
    match,
    handleClickLink,
    handleClickLike,
    handleClickKeep,
    handleCloseMatchModal,
  } = useCompanyJobDescriptionDetailV2Facade({
    isLogin,
    jdHash,
    mailReferrer,
    jobDescription,
  });

  if (isLogin && inputRequiredProfileRedirectStatus !== 'notRedirected') {
    return null;
  }

  // 求人票が見つからない場合
  if (!jobDescriptionDataForRender) {
    return <NotFoundV2 />;
  }

  return (
    <Row>
      <Column>
        <CompanyJobDescriptionDetail
          isBlockCompany={isBlockCompany}
          isFirstLoaded={isFirstLoaded}
          isLoading={isLoading}
          isLoadingCurrentUser={isLoadingCurrentUser}
          isLogin={isLogin}
          isOpenMatchModal={isOpenedMatchModal}
          isUserSuccessCommitmentJobInterview={
            isUserSuccessCommitmentJobInterview
          }
          jobDescription={jobDescriptionDataForRender}
          jobDescriptionLike={jobDescriptionLike}
          match={match}
          speakerDeckOembed={jobDescriptionSpeakerDeckOembed}
          user={{
            vision: currentUser?.profile?.vision,
            latestDevelopmentResults:
              currentUser?.profile?.latestDevelopmentResults,
          }}
          userLike={userLike}
          userPersonalityIds={userPersonalityIds}
          userSelfRecommendSkillIds={userSelfRecommendSkillIds}
          userSkillIds={userSkillIds}
          onClickKeep={handleClickKeep}
          onClickLike={handleClickLike}
          onClickLink={handleClickLink}
          onCloseMatchModal={handleCloseMatchModal}
        />
      </Column>
    </Row>
  );
};
